var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM2.4 12C2.4 17.3019 6.69807 21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69807 17.3019 2.4 12 2.4C6.69807 2.4 2.4 6.69807 2.4 12Z",
    fill: "#F5F7FB",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.20195C12 0.539208 12.5386 -0.00426388 13.198 0.0619001C14.3629 0.178781 15.5066 0.465728 16.5922 0.915397C18.0481 1.51845 19.371 2.40237 20.4853 3.51667C21.5996 4.63097 22.4835 5.95384 23.0866 7.40975C23.5362 8.49534 23.8232 9.63905 23.9401 10.8039C24.0062 11.4634 23.4627 12.002 22.8 12.002C22.1373 12.002 21.6077 11.4626 21.5251 10.8051C21.4184 9.95562 21.1982 9.12246 20.8692 8.32819C20.3868 7.16347 19.6797 6.10517 18.7882 5.21373C17.8968 4.32228 16.8385 3.61515 15.6738 3.13271C14.8795 2.80371 14.0463 2.58359 13.1969 2.47685C12.5393 2.39423 12 1.86469 12 1.20195Z",
    fill: "#985AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.02551e53c31575120533ab613ab90c7b.svg";
export { ForwardRef as ReactComponent };